import { createContext, useContext, type ReactNode } from "react";

import type { ModalType } from "~/components/main-layout";

interface ModalContextValue {
  isAnyModalOpen: boolean;
  openModal?: (modalType: ModalType) => void;
}

const ModalContext = createContext<ModalContextValue | undefined>(undefined);

export function ModalProvider({
  children,
  isAnyModalOpen,
  openModal,
}: {
  children: ReactNode;
  isAnyModalOpen: boolean;
  openModal?: (modalType: ModalType) => void;
}) {
  return (
    <ModalContext.Provider value={{ isAnyModalOpen, openModal }}>
      {children}
    </ModalContext.Provider>
  );
}

export function useModal() {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error("useModal must be used within a ModalProvider");
  }
  return context;
}
